import { Box, Button, Grid, IconButton, Typography } from '@mui/material';
import { useState } from 'react';
import getAPIUrl from '../../../config';
import postApi, { putApiWithAuth } from '../../../utils/apiCalls';
import EAdminRoles from '../../../utils/Enums';
import getLocalStorageData from '../../../utils/token';
import FormsPopup from '../../common/FormsPopup/FormsPopup';
import Popup from '../../common/Popup/Popup';
import { useToast } from '../../common/ToasterContext';
import UserAvatar from '../../common/UserAvatar/UserAvatar';
import styles from './styles';
import { AdminProfileProps } from './types';

const AdminProfileDetails = ({
    openAdminDetails,
    setOpenAdminDetails,
    userData,
    setEditAdminDetails,
    userActive,
    setUserActive,
    setReload,
}: AdminProfileProps) => {
    const [confirm, setConfirm] = useState<boolean>(false);
    const [showError, setShowError] = useState<boolean>(false);
    const loginInfo = getLocalStorageData();
    const toast = useToast();
    return (
        <FormsPopup
            id="user_prodile_details"
            open={openAdminDetails}
            title="User Profile"
            textAlign="left"
            handleClose={() => setOpenAdminDetails(false)}
            width={600}
        >
            <Box component="form" noValidate id="admin-details">
                <Grid container spacing={2} sx={styles.container}>
                    <Grid item xs={6}>
                        <UserAvatar
                            id="admin_proile_picture"
                            name={`${userData.firstname} ${userData.lastname}`}
                            source={userData?.signedUrl || ''}
                            size={279}
                            radius="16px"
                            fontSize={50}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography id="admin_complete_name" sx={styles.profileLable}>
                            Complete Name
                        </Typography>

                        <Typography
                            id={`${userData?.firstname} ${userData?.lastname}`}
                            sx={[styles.profileValue, styles.name]}
                        >
                            {userData?.firstname} {userData?.lastname}
                        </Typography>

                        <Typography id="admin_role" sx={styles.profileLable}>
                            Role
                        </Typography>

                        <Typography id={userData?.adminRole?.role} sx={styles.profileValue}>
                            {userData?.adminRole?.role}
                        </Typography>

                        <Typography id="admin_email" sx={styles.profileLable}>
                            Email
                        </Typography>

                        <Typography id={userData?.email} sx={styles.profileValue}>
                            {userData?.email}
                        </Typography>

                        <Typography sx={styles.profileLable}>Status: {userActive ? 'Active' : 'Inactive'}</Typography>

                        <IconButton
                            data-testid="userStatus"
                            sx={styles.profileValue}
                            disabled={
                                !(loginInfo?.roleName === EAdminRoles.LEADERSHIP) || loginInfo?.id === userData.id
                            }
                            onClick={() => {
                                setConfirm(true);
                            }}
                        >
                            <img
                                alt="status"
                                src={userActive ? '/images/active-toggle.png' : '/images/disable-toggle.png'}
                            />
                        </IconButton>
                    </Grid>
                    {loginInfo?.roleName === EAdminRoles.LEADERSHIP ? (
                        <Typography component="div">
                            <Button
                                id="passwordLink"
                                variant="text"
                                sx={styles.sendResetLink}
                                onClick={async () => {
                                    try {
                                        await postApi(`${getAPIUrl()}/admins/reset-password`, {
                                            email: userData?.email,
                                        });
                                        if (toast) {
                                            toast.onToggleSnackbar();
                                            toast.onMessage('Request Processeed');
                                            toast.onSuccess();
                                        }
                                    } catch (error: any) {
                                        if (toast) {
                                            toast.onToggleSnackbar();
                                            toast.onMessage(error.response.data.errors);
                                            toast.onError();
                                        }
                                    }
                                }}
                            >
                                Send Reset Password Link
                            </Button>
                            <Button
                                id="editUser"
                                variant="contained"
                                sx={styles.editUser}
                                onClick={() => {
                                    setOpenAdminDetails(false);
                                    setEditAdminDetails(true);
                                }}
                            >
                                Edit User
                            </Button>
                        </Typography>
                    ) : null}
                </Grid>
                <Popup
                    id={userActive ? 'confirmDeactivation' : 'confirmActivation'}
                    open={confirm}
                    title={userActive ? 'Confirm Deactivation' : 'Confirm Activation'}
                    textAlign="left"
                    handleClose={() => setConfirm(false)}
                    description={
                        <>{`Please confirm if you wish to ${userActive ? 'inactive' : 'active'} (${
                            userData?.firstname
                        } ${userData?.lastname}).Once confirmed, this user ${
                            userActive ? 'won`t' : 'will'
                        } be able to access Admin Portal.`}</>
                    }
                >
                    <>
                        <Button
                            id="cancel"
                            variant="outlined"
                            sx={styles.cancel}
                            onClick={() => {
                                setConfirm(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            id={`continue${userActive ? 'Dea' : 'A'}ctivation`}
                            variant="contained"
                            sx={styles.continue}
                            onClick={async () => {
                                try {
                                    const result = await putApiWithAuth(`${getAPIUrl()}/admins/update-admin-status`, {
                                        id: Number(userData?.id),
                                        isActive: !userActive,
                                    });
                                    setUserActive(result.data.data.isActive);
                                    if (toast) {
                                        toast.onToggleSnackbar();
                                        toast.onMessage('Request Processeed');
                                        toast.onSuccess();
                                    }
                                    if (setReload) setReload(true);
                                    setConfirm(false);
                                } catch (error: any) {
                                    setShowError(!showError);
                                    if (toast) {
                                        toast.onToggleSnackbar();
                                        toast.onMessage(error.response.data.errors);
                                        toast.onError();
                                    }
                                }
                            }}
                        >
                            Continue
                        </Button>
                    </>
                </Popup>
            </Box>
        </FormsPopup>
    );
};
export default AdminProfileDetails;
